import * as types from "./actionTypes";

export const get = () => {
  return {
    type: types.GET_COUNTRY_CODE_REQUEST
  };
};

export const getSuccess = data => {
  return {
    type: types.GET_COUNTRY_CODE_SUCCESS,
    payLoad: data.data
  };
};
export const getFailure = () => {
  return {
    type: types.GET_COUNTRY_CODE_FAILURE
  };
};
